module.exports = __webpack_public_path__ + "img/hiw-schema.db82e6e9.svg";